<div
	class="card zk-rounded-md zk-grid zk-cursor-pointer"
	[ngClass]="{
		'color-inactive': stage == stages.Blank || stage == stages.Inactive,
		'color-in-progress':
			stage == stages.InProgress ||
			stage == stages.RequestingChange ||
			stage == stages.WaitingApproval ||
			stage == stages.ChangeAccepted ||
			stage == stages.UpdateRequested,
		'color-active': stage == stages.Active || stage == stages.WaitingChange,
		selected: selected
	}"
	(click)="onSelect($event)"
>
	<div class="type-radio zk-py-4 zk-px-6">
		<div
			class="
				radio-option
				zk-mt-px zk-cursor-pointer zk-float-left zk-rounded-full
			"
			[class.active]="active"
			(click)="onSelect($event)"
		></div>
		<div class="title zk-font-thick zk-float-left zk-pl-4 zk-cursor-pointer">
			<ng-container *ngIf="businessType === 'natural'">
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_CARD.PERSONAL' | translate }}
				<span class="custom-badge zk-text-xs zk-rounded-md zk-ml-1">{{
					'MY_ACCOUNT.FINANCIAL.BILLING_CARD.FISCAL_ID' | translate
				}}</span>
			</ng-container>
			<ng-container *ngIf="businessType === 'legal'">
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_CARD.LEGAL_ENTITY' | translate }}
				<span class="custom-badge zk-text-xs zk-rounded-md zk-ml-1">{{
					'MY_ACCOUNT.FINANCIAL.BILLING_CARD.BUSINESS_FISCAL_ID' | translate
				}}</span>
			</ng-container>
		</div>
	</div>

	<div class="zk-py-4 zk-px-6 xl:zk-flex">
		<div
			class="description zk-text-xs zk-flex zk-cursor-pointer"
			[class.inactive]="stage == stages.Inactive"
		>
			<zk-icon
				name="approve-3"
				class="zk-w-4 zk-items-center zk-grid zk-mr-3"
				[height]="'14px'"
				[width]="'14px'"
				*ngIf="stage == stages.Active"
			>
			</zk-icon>
			<span class="zk-items-center zk-grid zk-whitespace-pre-line">{{
				stageMessage()
			}}</span>
		</div>
		<div class="zk-pt-2" *ngIf="showCancelButton()">
			<span
				class="
					cancel-button
					zk-font-thick
					lg:zk-pl-2
					zk-uppercase zk-cursor-pointer
				"
				(click)="onRequestCancel($event)"
			>
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_CARD.CANCEL' | translate }}
			</span>
		</div>
	</div>
</div>
